module.exports = __webpack_public_path__ + "static/media/sync-preview.9b357c76.png";